import { netsparkAxios } from 'core/services/HTTPService';
import { IUserProfileData } from 'layouts/BaseLayout/GetUserProfile/GetUserProfile.models';

import getUserProfileUrl from './apiUrls';

const getUserProfile = (signal: AbortSignal) => netsparkAxios
  .get<IUserProfileData>(getUserProfileUrl, { signal });

export default getUserProfile;
